import DateEditor from './DateEditor.vue';

export default DateEditor;
